module.exports = __webpack_public_path__ + "img/logo.f3a37b4c.png";